import React from 'react';
import { motion } from 'framer-motion';
import '../csscomponent/GrooveLogoBadge.css';

export default function GrooveLogoBadge({ className = '' }) {
  return (
    <motion.div
      className={`groove-logo-badge ${className}`.trim()}
      initial={{ opacity: 0, scale: 0.92, y: 10 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.55, ease: 'easeOut' }}
    >
      <span className="groove-logo-ring" aria-hidden="true" />
      <span className="groove-logo-shine" aria-hidden="true" />
      <div className="groove-logo-content">
        <span className="groove-logo-mark">
          S&amp;<span className="groove-logo-mark-d">D</span>
        </span>
        <span className="groove-logo-sub">Studio</span>
      </div>
    </motion.div>
  );
}
